import { useEffect } from "react";
import { CustomState } from "../../../../Hooks/State.hook";
import StyledMessagesByContact from "./style";
import { ContactMessages, MessagesPerContactResponse } from "./types";
import { customRequest, CustomRequestOptions } from "../../../../services/api";
import ContactsMessagesTable from "./table";
import { RangeDate } from "../../../../interfaces/generics.types";
import toSqlDate from "../../../../Hooks/toSqlDate.util";
import InputDateRange from "../../../../components/InputDateRange";
import { defaultInput50, defaultSelect100 } from "../../../../components-variants/defaultInputs";
import { ButtonType1 } from "../../../../styles/buttons.style";
import { FaFilter } from "react-icons/fa6";
import { UserData } from "../../../../interfaces/Users.interfaces";
import Select from "../../../../components/Select";
import LoadingSpinner from "../../../../components/LoadingSpinner";

function MessagesByContact() {
    const messagesByContactState = CustomState<ContactMessages[]>([]);
    const filteredMessagesByContactState = CustomState<ContactMessages[]>([]);
    const usersState = CustomState<UserData[]>([]);
    const loadingState = CustomState<boolean>(false);

    const dt = new Date();

    const dateFilterState = CustomState<RangeDate>({
        min: new Date(dt.getFullYear(), dt.getMonth(), 1),
        max: new Date(dt.getFullYear(), dt.getMonth() + 1, 0)
    });
    const userFilterState = CustomState<number | null>(null);

    function loadMessagesByContact(range: RangeDate, user: number | null) {
        const requestData: CustomRequestOptions<MessagesPerContactResponse, undefined> = {
            endpoint: "/dashboard/messages-per-contact",
            method: "get",
            onSuccess: (res) => {
                messagesByContactState.set(res.messagesPerContact);
                filteredMessagesByContactState.set(res.messagesPerContact);
            },
            loadingState,
            timeoutSeconds: 90
        }

        requestData.params = {};

        if (range.min || range.max) {
            const minDate = range.min ? toSqlDate(range.min) : "";
            const maxDate = range.max ? toSqlDate(range.max) : "";

            requestData.params["date"] = `${minDate}_${maxDate}`;
        }

        if (!!user) {
            requestData.params["user"] = user;
        }

        customRequest(requestData);
    }

    useEffect(() => {
        customRequest<UserData[], undefined>({
            endpoint: "/operators",
            method: "get",
            onSuccess: (data) => usersState.set(data.filter(u => u.CODIGO > 0)),
        });

        loadMessagesByContact(dateFilterState.value, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <StyledMessagesByContact>
            <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <div style={{ width: "40rem" }}>
                    <InputDateRange
                        title="Período"
                        state={dateFilterState}
                        {...defaultInput50}
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "20rem" }}>
                    <Select
                        {...defaultSelect100}
                        options={usersState.value.map(u => ({ name: u.NOME, value: u.CODIGO, key: u.CODIGO }))}
                        onChange={(v) => userFilterState.set(v)}
                        placeholder="Usuário"
                    />
                    <ButtonType1
                        style={{ fontSize: "1rem" }}
                        onClick={() => loadMessagesByContact(dateFilterState.value, userFilterState.value)}
                    >
                        <FaFilter />
                        Filtrar
                    </ButtonType1>
                </div>
            </div>

            {
                loadingState.value ?
                    <LoadingSpinner /> :
                    <ContactsMessagesTable
                        rowsState={messagesByContactState}
                        filteredRowsState={filteredMessagesByContactState}
                    />
            }
        </StyledMessagesByContact>
    );
}

export default MessagesByContact;